export const links = [
  {
    id: 1,
    name: "Home",
    icon: "fa-solid fa-house",
    link: "header",
  },
  {
    id: 2,
    name: "About",
    icon: "fa-regular fa-face-smile-wink",
    link: "about",
  },
  {
    id: 3,
    name: "Menu",
    icon: "fa-solid fa-utensils",
    link: "menu",
  },
  // {
  //   id: 4,
  //   name: "wine",
  //   icon: "fa-solid fa-wine-glass",
  //   link: "wine",
  // },
  {
    id: 5,
    name: "Book",
    icon: "fa-regular fa-calendar-check",
    link: "book",
  },
  {
    id: 6,
    name: "contact",
    icon: "fa-solid fa-globe",
    link: "contact",
  },
];
export const socialLinks = [
  {
    id: 1,
    name: "facebook",
    icon: "fa-brands fa-facebook",
    link: "https://www.facebook.com/",
  },
  {
    id: 2,
    name: "instagram",
    icon: "fa-brands fa-instagram",
    link: "https://www.instagram.com/",
  },
  {
    id: 3,
    name: "twitter",
    icon: "fa-brands fa-twitter",
    link: "https://twitter.com/",
  },
];

export const menu = [
  {
    id: 1,
    category: "pizza",
    name: "Emiliana",
    description:
      "Italian soft crust pizza with cured meat and cheese toppings.",
    ingredients:
      "Tomato sauce, mozzarella, eggplant, boiled potatoes, and sausage",
    alergens: "milk",
    price: 9.99,
    image: "./images/menu/pizza1.jpg",
  },
  {
    id: 2,
    category: "pizza",
    name: "Romana",
    description:
      "Thin, crispy-crusted pizza from Rome, Italy, typically topped with simple ingredients",
    ingredients: "Tomato sauce, mozzarella, anchovies, capers, and oregano",
    alergens: "milk",
    price: 8.99,
    image: "./images/menu/pizza2.jpg",
  },
  {
    id: 3,
    category: "pizza",
    name: "Fattoria",
    description:
      "Farm-to-table pizza with fresh, locally sourced ingredients, made in the traditional Italian style.",
    alergens: "milk",
    price: 7.99,
    image: "./images/menu/pizza3.jpg",
  },
  {
    id: 4,
    category: "pizza",
    name: "Schiacciata",
    description: "A Tuscan-style pizza with a soft, flattened dough.",
    ingredients: "Olive oil and rosemary",
    alergens: "milk",
    price: 8.99,
    image: "./images/menu/pizza4.jpg",
  },
  {
    id: 5,
    category: "pizza",
    name: "Prosciutto",
    description:
      "A symphony of salty and savory, where thin-sliced ham sings atop a crust of melted cheese. A medley of flavor, with each bite a harmonious blend of tangy tomato and peppery arugula. ",
    ingredients: "Tomato sauce, mozzarella, ham, and oregano",
    alergens: "milk",
    price: 9.99,
    image: "./images/menu/pizza5.jpg",
  },
  {
    id: 6,
    category: "pizza",
    name: "Americana",
    description:
      "A classic American-style pizza, known for its thick, chewy crust, abundant toppings, and generous portions. A timeless crowd-pleaser that combines melted cheese, savory meats, and tangy sauces in every bite.",
    ingredients: "Tomato sauce, mozzarella, sausage and french fries",
    alergens: "milk",
    price: 7.99,
    image: "./images/menu/pizza6.jpg",
  },
  {
    id: 7,
    category: "pizza",
    name: "Prosciutto e Funghi",
    description:
      " A delicious combination of earthy and salty flavors, perfectly balanced on a crispy crust.",
    ingredients: "Tomato sauce, mozzarella, ham, and mushrooms",
    alergens: "milk",
    price: 7.99,
    image: "./images/menu/pizza7.jpg",
  },
  {
    id: 8,
    category: "pizza",
    name: "Braccio di Ferro",
    description:
      "A pizza as strong as its name, where the power of iron-rich spinach meets the melted embrace of mozzarella cheese.",
    ingredients: "Mozzarella, spinach, ricotta cheese, and parmesan",
    alergens: "milk",
    price: 9.99,
    image: "./images/menu/pizza8.jpg",
  },
  {
    id: 9,
    category: "pizza",
    name: "Sarda",
    description:
      "A celebration of Sardinia's bounty, each bite a savory dance of flavors, a symphony of earthy and tangy. A true taste of the island, crafted with care and love.",
    ingredients: " Tomato sauce, mozzarella, pecorino cheese, and spicy salami",
    alergens: "milk",
    price: 8.99,
    image: "./images/menu/pizza9.jpg",
  },
  {
    id: 10,
    category: "pizza",
    name: "Tonno",
    description:
      "A true delight from the Italian coast, each slice a journey to taste's bliss.",
    ingredients: "Tomato sauce, mozzarella, tuna, and onions",
    alergens: "milk",
    price: 9.99,
    image: "./images/menu/pizza10.jpg",
  },

  {
    id: 11,
    category: "pasta",
    name: "La Carbonara",
    description:
      "Silken strands, bathed in a rich, velvety sauce of eggs, bacon, and cheese. A dance of flavors, each bite a luxurious experience, indulging the senses and satisfying the soul.",
    ingredients:
      "browned guanciale, black pepper, pecorino Romano and beaten eggs",
    alergens: "milk",
    price: 12,
    image: "./images/menu/paste1.jpg",
  },
  {
    id: 12,
    category: "pasta",
    name: "Cacio e Pepe",
    description:
      "Linguine strands twirl in a sea of melted cheese and cracked black pepper, creating a simple yet decadent symphony of flavors. A dish that speaks to the heart and delights the taste buds, with every bite a celebration of simplicity and taste.",
    ingredients: "black pepper and Pecorino Romano",
    alergens: "milk",
    price: 13,
    image: "./images/menu/paste2.jpg",
  },
  {
    id: 13,
    category: "pasta",
    name: "Bucatini all'Amatriciana",
    description:
      "Thick, hollow strands of pasta, drenched in a spicy tomato sauce, dotted with salty pancetta, and crowned with a sprinkle of sharp pecorino. A feast of flavor, each bite a journey through the rustic countryside of Italy.",
    ingredients: "sliced guanciale, onion, tomatoes",
    alergens: "milk",
    price: 11,
    image: "./images/menu/paste3.jpg",
  },
  {
    id: 14,
    category: "pasta",
    name: "Penne all'Arrabbiata",
    description:
      "Short tubes of pasta, bathed in a fiery tomato sauce, spiced with chili flakes and kissed with basil. A bold, flavorful dance of heat and tang, each bite a fiery embrace of Italian passion.",
    ingredients:
      "Olive oil, red pepper flakes, onnion, garlic, tomatoes, basil",
    alergens: "milk",
    price: 12,
    image: "./images/menu/paste4.jpg",
  },
  {
    id: 15,
    category: "pasta",
    name: "Spaghetti Bolognese",
    description:
      "Long strands of pasta, twirled with a hearty meat sauce, dotted with carrots, onions, and tomatoes. A comfort food classic, each bite a warm, comforting embrace, reminding us of home and family.",
    ingredients: "ground beef, onions, tomatoes and fresh herbs",
    alergens: "milk",
    price: 13,
    image: "./images/menu/paste5.jpg",
  },
  {
    id: 16,
    category: "pasta",
    name: "Spaghetti allo Scoglio",
    description:
      "Long strands of pasta, tangled with a medley of seafood, bathed in a light tomato broth. A taste of the sea, each bite a journey to the Italian coast, filled with the flavors of the ocean.",
    ingredients: "Tomato sauce, mozzarella, sausage and french fries",
    alergens: "milk",
    price: 11,
    image: "./images/menu/paste6.jpg",
  },
  {
    id: 17,
    category: "pasta",
    name: "Trofie al Pesto",
    description:
      "Short, twisted pasta, coated in a vibrant basil pesto, studded with juicy cherry tomatoes, and grated with Parmesan. A burst of flavor with each bite, a tribute to the bright and bold flavors of Italy's sunny Liguria region.",
    ingredients: "mussels, squid, white wine, clams",
    alergens: "milk",
    price: 12,
    image: "./images/menu/paste7.jpg",
  },
  {
    id: 18,
    category: "pasta",
    name: "Ravioli Burro e Salvia",
    description:
      "Soft pillows of pasta, filled with rich, creamy cheese, swimming in a warm pool of butter and sage. A indulgent symphony of flavors, each bite a luxurious experience, satisfying both body and soul.",
    ingredients: "sage, butter, parmigiano reggiano",
    alergens: "milk",
    price: 13,
    image: "./images/menu/paste8.jpg",
  },
  {
    id: 19,
    category: "pasta",
    name: "Gnocchi alla Sorrentina",
    description:
      "Soft, pillowy dumplings, smothered in a rich tomato sauce, studded with mozzarella and sprinkled with basil. A flavor-packed comfort food, each bite a warm and delicious embrace, reminiscent of the sunny coast of Sorrento.",
    ingredients: "Mozzarella cheese, olive oil, egg yolks",
    alergens: "milk",
    price: 11,
    image: "./images/menu/paste9.jpg",
  },
  {
    id: 20,
    category: "pasta",
    name: "Spaghetti alla Puttanesca",
    description:
      "Long strands of pasta, tangled with a bold, spicy tomato sauce, dotted with olives, capers, and anchovies. A dish with a lively, robust flavor, each bite a celebration of Italian passion, flavor and heritage.",
    ingredients: "red pepper flakes, black olives, capers, tomato",
    alergens: "milk",
    price: 12,
    image: "./images/menu/paste10.jpg",
  },
];
